import { createContext, useContext } from 'react';

import { useStores } from '../../stores/useStores';
import type { WizardStore } from '../../stores/wizard/WizardStore';

export const WizardStoreContext = createContext<WizardStore | null>(null);

export function useWizardStore(): WizardStore {
  const contextWizardStore = useContext(WizardStoreContext);
  const { wizardStore: globalWizardStore } = useStores();

  return contextWizardStore || globalWizardStore;
}
